import { render, staticRenderFns } from "./QuestionCompletedBlock.vue?vue&type=template&id=0be5b731&"
import script from "./QuestionCompletedBlock.vue?vue&type=script&lang=js&"
export * from "./QuestionCompletedBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports